<div class="flex flex-col mt-2" [formGroup]="formGroup()">
  <div
    [ngClass]="{
      'grid gap-4 items-start': layout() === 'threeCol' || columnSize() === 'quarter',
      'flex flex-col gap-2': layout() === 'default' && columnSize() === 'full',
      'md:flex-row': layout() === 'default' && columnSize() === 'full' && !stackCountryStreet(),
      'grid-cols-3': layout() === 'threeCol',
      'grid-cols-1 md:grid-cols-4': layout() === 'default' && columnSize() === 'quarter',
    }">
    <div
      [ngClass]="{
        'md:col-span-1': layout() === 'default' && columnSize() === 'quarter',
        'w-full': layout() === 'default' && columnSize() === 'full' && stackCountryStreet(),
        'w-full md:basis-1/3': layout() === 'default' && columnSize() === 'full' && !stackCountryStreet(),
      }">
      <ng-container *ngTemplateOutlet="countryTpl"></ng-container>
    </div>

    <div
      [ngClass]="{
        'md:col-span-1': layout() === 'default' && columnSize() === 'quarter',
        'w-full':
          (layout() === 'default' && columnSize() === 'full' && stackCountryStreet()) || layout() === 'threeCol',
        'w-full md:basis-2/3': layout() === 'default' && columnSize() === 'full' && !stackCountryStreet(),
      }">
      <ng-container *ngTemplateOutlet="streetTpl"></ng-container>
    </div>

    @if (layout() === 'default' && columnSize() === 'quarter') {
      <div class="md:col-span-2"></div>
    }

    @if (layout() === 'threeCol') {
      <div [formGroup]="formGroup()" class="w-full">
        <ng-container *ngTemplateOutlet="cityFieldTpl"></ng-container>
      </div>
    }
  </div>

  <div
    [ngClass]="{
      'grid gap-4 mt-2 items-start': true,
      'grid-cols-3': layout() === 'threeCol' || (layout() === 'default' && columnSize() === 'full'),
      'grid-cols-1 md:grid-cols-4': layout() === 'default' && columnSize() === 'quarter',
    }">
    @if (layout() === 'default') {
      <div [formGroup]="formGroup()" class="w-full md:col-span-1">
        <ng-container *ngTemplateOutlet="cityFieldTpl"></ng-container>
      </div>
    }

    @if (!isUsaCountry) {
      <mat-form-field
        [color]="color()"
        [appearance]="appearance()"
        [floatLabel]="floatLabel()"
        class="w-full md:col-span-1 self-start">
        <mat-label>State / Province</mat-label>
        <input
          matInput
          type="text"
          formControlName="province"
          (blur)="trimField('province')"
          (keydown.enter)="trimField('province')" />
        @if (formGroup().controls.province.errors?.maxlength) {
          <mat-error> Cannot exceed 30 characters </mat-error>
        } @else if (formGroup().controls.province.errors?.onlySpecialChars) {
          <mat-error>
            {{ getOnlySpecialCharsMessage('province') }}
          </mat-error>
        }
      </mat-form-field>
    }

    @if (isUsaCountry) {
      <mat-form-field
        [color]="color()"
        [appearance]="appearance()"
        [floatLabel]="floatLabel()"
        class="w-full md:col-span-1 self-start">
        <mat-label>State Code *</mat-label>
        <input
          matInput
          type="text"
          formControlName="state"
          maxlength="2"
          (blur)="trimField('state')"
          (keydown.enter)="trimField('state')" />
        @if (formGroup().controls.state.errors?.required) {
          <mat-error> State is required </mat-error>
        } @else if (formGroup().controls.state.errors?.invalidChars) {
          <mat-error>No numbers and special characters allowed</mat-error>
        } @else if (formGroup().controls.state.errors?.hasSpaces) {
          <mat-error>Cannot contain spaces</mat-error>
        } @else if (formGroup().controls.state.errors?.invalidLength) {
          <mat-error>State code must be exactly 2 characters</mat-error>
        } @else if (formGroup().controls.state.errors?.invalidStateCode) {
          <mat-error>Must be a valid US state code</mat-error>
        }
      </mat-form-field>
    }

    <mat-form-field
      [color]="color()"
      [appearance]="appearance()"
      [floatLabel]="floatLabel()"
      class="w-full md:col-span-1 self-start">
      <mat-label>{{ isPostalCodeRequired ? 'Zip/Postal Code *' : 'Zip/Postal Code' }}</mat-label>
      <input
        matInput
        type="text"
        formControlName="postalCode"
        (blur)="trimField('postalCode')"
        (keydown.enter)="trimField('postalCode')" />
      @if (shouldShowPostalCodeError()) {
        <mat-error>
          @if (formGroup().controls.postalCode.errors?.required) {
            <span> Zip is required</span>
          } @else if (formGroup().controls.postalCode.errors?.invalidUsZipCodeFormat) {
            <span>Must be a valid 5-digit ZIP code</span>
          } @else if (formGroup().controls.postalCode.errors?.invalidUsZipCode) {
            <span>Invalid US ZIP code</span>
          } @else if (formGroup().controls.postalCode.errors?.zipCodeNotFound) {
            <span>Invalid US ZIP code</span>
          } @else if (formGroup().controls.postalCode.errors?.stateMismatch) {
            <span
              >The ZIP Code you entered isn't valid for the selected state. Please check the ZIP or update the
              state.</span
            >
          } @else if (!isPostalCodeRequired && formGroup().controls.postalCode.errors?.maxlength) {
            <span>Cannot exceed 20 characters</span>
          } @else if (formGroup().controls.postalCode.errors?.onlySpecialChars) {
            <span>{{ getOnlySpecialCharsMessage('postalCode') }}</span>
          }
        </mat-error>
      }
    </mat-form-field>

    @if (layout() === 'threeCol' || columnSize() === 'quarter') {
      <div class="md:col-span-1">
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>

<ng-template #countryTpl>
  <mat-form-field
    [formGroup]="formGroup()"
    [color]="color()"
    [appearance]="appearance()"
    [floatLabel]="floatLabel()"
    class="w-full">
    <mat-label>Country *</mat-label>
    <input
      matInput
      type="text"
      [formControl]="countrySearchControl"
      [matAutocomplete]="countryAuto"
      [readonly]="isSingleCountry"
      (blur)="onCountryBlur()" />
    @if (countrySearchControl.value && !isSingleCountry) {
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="clearCountrySearch($event)"
        [disabled]="disabled() || formGroup().disabled">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete #countryAuto="matAutocomplete" (optionSelected)="onCountrySelected($event.option.value)">
      @for (country of filteredCountries; track country.alpha2) {
        <mat-option [value]="country">
          {{ country.name }} ({{ countryDisplayFormat() === '3' ? country.alpha3 : country.alpha2 }})
        </mat-option>
      }
    </mat-autocomplete>
    @if (
      countrySearchControl.touched ||
      countrySearchControl.dirty ||
      formGroup().controls.country?.touched ||
      formGroup().controls.country?.dirty
    ) {
      @if (countrySearchControl.errors?.required) {
        <mat-error>Country is required</mat-error>
      } @else if (countrySearchControl.errors?.invalidCountrySelection) {
        <mat-error>Please select an option from the list</mat-error>
      } @else if (formGroup().controls.country?.errors?.invalidCountry) {
        <mat-error>Only US is allowed as country</mat-error>
      }
    }
  </mat-form-field>
</ng-template>

<ng-template #streetTpl>
  <mat-form-field
    [formGroup]="formGroup()"
    [color]="color()"
    [appearance]="appearance()"
    [floatLabel]="floatLabel()"
    class="w-full">
    <mat-label>Street Address *</mat-label>
    <input
      matInput
      type="text"
      formControlName="street"
      (blur)="trimField('street')"
      (keydown.enter)="trimField('street')"
      [matAutocomplete]="streetAuto"
      #streetTrigger="matAutocompleteTrigger" />
    @if (enableAddressSearch()) {
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="formGroup().controls.street.invalid ? null : searchAddress(true)"
        [disabled]="disabled() || formGroup().disabled || formGroup().controls.street.invalid">
        <mat-icon>search</mat-icon>
      </button>
    }
    <mat-autocomplete #streetAuto="matAutocomplete" (optionSelected)="selectAddress($event.option.value)">
      @for (result of addressResults; track result.formatted) {
        <mat-option [value]="result">
          {{ result.formatted }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (formGroup().controls.street.errors?.required) {
      <mat-error>Street address is required</mat-error>
    } @else if (formGroup().controls.street.errors?.maxlength) {
      <mat-error>Cannot exceed 100 characters</mat-error>
    } @else if (formGroup().controls.street.errors?.onlySpecialChars) {
      <mat-error>Enter valid address with letters and numbers. It can't be only symbols</mat-error>
    } @else if (
      formGroup().controls.street.errors?.startsWithSpecialChar && !formGroup().controls.street.errors?.onlySpecialChars
    ) {
      <mat-error>Address cannot start with a special character</mat-error>
    }
  </mat-form-field>
</ng-template>

<ng-template #cityFieldTpl>
  <mat-form-field
    [formGroup]="formGroup()"
    [color]="color()"
    [appearance]="appearance()"
    [floatLabel]="floatLabel()"
    class="w-full">
    <mat-label>City *</mat-label>
    <input matInput type="text" formControlName="city" (blur)="trimField('city')" (keydown.enter)="trimField('city')" />
    @if (formGroup().controls.city.errors?.required) {
      <mat-error>City is required</mat-error>
    } @else if (formGroup().controls.city.errors?.maxlength) {
      <mat-error>Cannot exceed 30 characters</mat-error>
    } @else if (formGroup().controls.city.errors?.onlySpecialChars) {
      <mat-error>Enter valid city with letters and numbers. It can't be only symbols</mat-error>
    } @else if (
      formGroup().controls.city.errors?.startsWithSpecialChar && !formGroup().controls.city.errors?.onlySpecialChars
    ) {
      <mat-error>City cannot start with a special character</mat-error>
    }
  </mat-form-field>
</ng-template>
